<div class="container-fluid m-0 p-0">

  <div class="pl-2">
    <div class="review-content col-auto section-bc pb-3">
      <div class="row m-0 p-0 justify-content-end d-none d-xl-flex">
        <button type="button"
                class="btn bg-transparent m-0 p-1 d-none d-sm-flex" (click)="collapseToggle()">
          <i class="primary-color fas fa-angle-double-left" *ngIf="minimizedReview"
             title="{{'RESIZE_UP' | translate}}"></i>
          <i class="primary-color fas fa-angle-double-right" *ngIf="!minimizedReview"
             title="{{'RESIZE_DOWN'| translate}}"></i>
        </button>
      </div>
      <div *ngIf="minimizedReview" class="row align-items-center p-2 d-flex d-xl-none" style="overflow-wrap: anywhere;">
        <h6 class="primary-color" *ngIf="offersSelected">{{'REQUEST_REVIEW' | translate}}</h6>
        <h6 class="primary-color" *ngIf="data.operation">{{'REVIEW' | translate}}</h6>
      </div>
      <div *ngIf="!minimizedReview" class="row align-items-center p-2" style="overflow-wrap: anywhere;">
        <h6 class="primary-color" *ngIf="offersSelected">{{'REQUEST_REVIEW' | translate}}</h6>
        <h6 class="primary-color" *ngIf="data.operation">{{'REVIEW' | translate}}</h6>
      </div>

      <!------------------------------      in caso di flusso di nuovo ordine------------------------------------------>
      <ng-container *ngIf="offersSelected">
        <app-request-flow-info-box [minimizedReview]="minimizedReview" [data]="data"

                                   [offersSelected]="offersSelected"
        ></app-request-flow-info-box>
      </ng-container>

      <!----------------------------------      in caso di flusso di riconoscimento------------------------------------>
      <ng-container
        *ngIf="this.data.operation === IdentificationTypeConstants.OFFLINE || this.data.operation === IdentificationTypeConstants.LIVEID || this.data.operation === IdentificationTypeConstants.WEBID">
        <app-recognition-flow-info-box [minimizedReview]="minimizedReview" [data]="data"
                                       [product]="product"
                                       [order]="order"></app-recognition-flow-info-box>
      </ng-container>

    </div>
  </div>
</div>

